import AppHeader from '../../components/app-header';
import KeySecretComponent from 'components/Key-Secret-Holder/keysecretcomponent';

function MainPage(): JSX.Element{
return(
<div>
    <AppHeader/>

    <div>
    <KeySecretComponent/>
    </div>
</div>
)




};
export default MainPage